var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_83_756",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_83_756",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAECElEQVR4nO2cPU9UQRSGBxuNxtJE1LAw5+LCDF+JjR0V4Z6zQGPtT0DFZNHEROJXYWtjtDQaez9+gDZKokYLsVIkMeEHIBEqzLBrJMDuvbvs3jNz97zJVJvcnHn23XdmTu6OUiKRSCQSiUQikUgkEolEIlUojB+xGi9bwEWj6bcF2srjMG5uGt8PaboURfHhTL/64Sg+Y4C+cEOwWUMH/OzmnpmTOxGy3QE7E2dX4oJ/wpYVNs22HzTgIvdELffQ9K79oDWtsU8U2EGvtR809yTBjyGgQUBvcbtQHA384CQ6gB+qZDQIaHbHWXE0sUOS6AB+gOFmtKYNq6k80DPZrTyTq8lqnLcaN/MAuqw8l9Gla8GDNgU6qTyXqzF40D5Gxm6N9pdOBw/aZaDyXEbT9ZwshjhfLM6cUp7J1bSdz7lYDHM6lIAmAW09cKI4GvjhSXQAP1jJaBDQ7K6z4mhiByXRAfwQw8xopjbpwAFaoKGCLqvAWqBBguZuk5omWqBBguZuk4420QINEjR3m9Q00QINFDRPm/QgLdAwQed0KAFNAtp64ERxNLQQRGVdeDAQxedHRiaOneueOmqi2Ng+vGCBbligZ1bjRwO4LtEBzUE2Gn+ZfhpLGaFdxcJkrwGKDeBVA/hq+0uSjKYEJ+NmA5D31VgUnzCaXshiCHXcDPSwRZuBLqPpnuw6YH/QQ1E8rlooo/GubO9gL2j3s1ctlgW6HcY+2oO3SQ3gN6vxjQV8ZHV8xUJpcrCXCi4imnW2j6DLbS8qsWZ8W6O2NQP4wWh8UgWfGnYGRYf3NqnV9Di5VlwZOTvdV/c5gLe8Bc3dJnUyEc2lqzc9bOVfdPC/TeoOJKl/gRp/pIkRTxdDZH2b1J3+Goq7FLD9A53hMIDrSi0c2lv1wqHGryPCleH+klZc4oZpE0YtJ1pNnxp/HiNsbpA20dUU16j7aZPPXGaJEe9BRzS3X91uN2EBfwYDOwBHv6xVu9FTPW6ha+7ZGccIN0ibNDRt1Ot5BONsdpCQaryu18cIwtkeQNxKMwzgnXrzOKiz3d5cQMM/2HS/Hoyqs7976ezQrmMzocIO8YJBkxAjlSO6ZzHibp3lBmc7Aba7ANVdhMoNzvoEW9PGUB9OqPZcayywbRXyoEZU7VLF2TTrLkQNb4HEFM6mZXbInSCTtBtxrwNH8TR3nblQsZazUzjZZXbbDzW5hq2TIbvPq+/wtf8EmUvYuiHIlfVA41KxOHM8u2pzADtpC7cb8n/YdDO7SnOuWpCrcfOVu778Q66MP9w1dgJk13xa5a4zaLnMTvMPAQP4nLvWoJXqBOkONr2lUe5ag9f2f2A0LtWEDHSRu0aVF7l9stvCud1FJUpw1cXFTif/BYpfIbztJ63aAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMemo);
export default __webpack_public_path__ + "static/media/ic_memo.32cae36652bef82c855429b90897572d.svg";
export { ForwardRef as ReactComponent };